import trapFocus from "./TrapFocus";
import addEmptyAltToImages from "./AltImages"

document.addEventListener('DOMContentLoaded', function () {
    const trad = {
        openSubmenu: {
            fr : 'Ouvrir le sous-menu',
            en : 'Open submenu',
            de : 'Untermenü öffnen'
        },
        closeSubmenu: {
            fr : 'Fermer le sous-menu',
            en : 'Close submenu',
            de : 'Untermenü schliessen'
        },
    }
    const submenuButtons = document.querySelectorAll('.section-header .menu-item-has-children');

    submenuButtons.forEach(button => {
        const submenu = button.querySelector('.sub-menu');
        const buttonA = button.querySelector('a')

        submenu.hidden = true;

        buttonA.addEventListener('click', () => {
            const isOpen = buttonA.getAttribute('aria-expanded') === 'true';

            buttonA.setAttribute('aria-expanded', String(!isOpen));
            buttonA.setAttribute('aria-label', isOpen ? trad.openSubmenu[document.querySelector('html').lang] : trad.closeSubmenu[document.querySelector('html').lang]);
            submenu.hidden = isOpen;
        });

        buttonA.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                buttonA.click();
            }
        });
        

        // close submenu after tab last item
        const focusableLinks = submenu.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
        const lastItem = focusableLinks[focusableLinks.length - 1];

        if (lastItem) {
            lastItem.addEventListener('keydown', (e) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                    buttonA.setAttribute('aria-expanded', 'false');
                    buttonA.setAttribute('aria-label', trad.openSubmenu[document.querySelector('html').lang]);
                    submenu.hidden = true;
                }
            });
        }
    });
    if(window.innerWidth < 1025) {
        trapFocus(document.querySelector('.ia-block-navigation--main'))
    }
    addEmptyAltToImages()


    if(!!document.querySelector('.is-style-list-anchor')) {
        document.querySelectorAll('.is-style-list-anchor').forEach(element => {
            if(element.parentElement.tagName.toLowerCase() !== 'nav'){
                const nav = document.createElement('nav')
                nav.setAttribute('aria-label', 'summary')
                nav.setAttribute('class', 'nav-is-style-list-anchor ')
                element.parentNode.insertBefore(nav, element)
                nav.appendChild(element)
            }
        });
    }
});


